import { SxProps, Theme } from '@mui/material';

export const userButtonStyles: SxProps<Theme> = {
  backgroundColor: 'var(--paper)',
  color: 'var(--text)',
  display: 'flex',
  padding: { xs: '5px', md: '8px 11px' },
};

export const menuItemLayout = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  px: 2,
  py: 1,
};
